import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { api, type Blog, type BlogDetail } from '../lib/api'

const LAUNCHER_COVER = '/image/minecraft-launcher-latest.png'
const LAUNCHER_JAVA = '/image/minecraft-launcher-java.png'

function blogCover(b: Blog, i = 0) {
  if (b.image_url) return b.image_url
  return i % 2 === 0 ? LAUNCHER_COVER : LAUNCHER_JAVA
}

export function BlogListPage() {
  const [items, setItems] = useState<Blog[]>([])
  const [total, setTotal] = useState(0)
  useEffect(() => {
    api.blogs(30).then((r) => {
      setItems(r.items)
      setTotal(r.total)
    })
  }, [])
  return (
    <>
      <h1 className="page-title">Bài viết</h1>
      <p className="page-lead">{total} bài đang hoạt động.</p>
      <div className="blog-grid">
        {items.map((b, i) => (
          <Link key={b.id} className="blog-card card-link" to={`/blog/${b.slug}`}>
            <div className="blog-card-media">
              <img src={blogCover(b, i)} alt="" loading="lazy" />
            </div>
            <div className="blog-card-body">
              <h3>{b.title}</h3>
              <p>{b.excerpt?.replace(/<[^>]+>/g, '').slice(0, 120)}</p>
            </div>
          </Link>
        ))}
      </div>
    </>
  )
}

export function BlogDetailPage() {
  const { uri = '' } = useParams()
  const [blog, setBlog] = useState<BlogDetail | null>(null)
  const [err, setErr] = useState('')
  useEffect(() => {
    api
      .blog(decodeURIComponent(uri))
      .then((r) => setBlog(r.blog))
      .catch((e) => setErr(e.message))
  }, [uri])
  if (err) return <p className="note">{err}</p>
  if (!blog) return <p className="muted">Đang tải…</p>
  const pack = blog.pack
  const back = pack ? (blog.is_shader ? ['/shader-pack', 'Shader Pack'] : ['/tai-nguyen', 'Resource Pack']) : ['/blog', 'Blog']
  return (
    <>
      <p className="muted">
        <Link to={back[0]}>← {back[1]}</Link>
      </p>
      <div className="blog-detail-hero">
        <img
          src={blog.image_url || LAUNCHER_COVER}
          alt=""
        />
      </div>
      <h1 className="page-title">{blog.title}</h1>
      {pack && blog.excerpt && <p className="page-lead">{blog.excerpt.replace(/<[^>]+>/g, '')}</p>}
      {blog.content?.trim() ? (
        <article
          className="panel prose"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />
      ) : null}
      {pack && (
        <div className="pack-extra">
          {pack.downloads.length > 0 && (
            <section className="panel">
              <h2 className="pack-h">Tải xuống</h2>
              <div className="pack-dl">
                {pack.downloads.map((d) => (
                  <a key={d.url} className="btn btn-primary" href={d.url} target="_blank" rel="noreferrer nofollow">
                    <i className="las la-download" aria-hidden /> {d.label}
                  </a>
                ))}
              </div>
            </section>
          )}
          {pack.versions.length > 0 && (
            <section className="panel">
              <h2 className="pack-h">Phiên bản hỗ trợ</h2>
              <div className="pack-vers">
                {pack.versions.map((v) => (
                  <Link key={v} className="rp-chip" to={`${back[0]}?version=${v}`}>
                    {v}
                  </Link>
                ))}
              </div>
            </section>
          )}
          {pack.gallery.length > 0 && (
            <section className="panel">
              <h2 className="pack-h">Hình ảnh</h2>
              <div className="pack-gallery">
                {pack.gallery.map((src) => (
                  <a key={src} href={src} target="_blank" rel="noreferrer">
                    <img src={src} alt="" loading="lazy" />
                  </a>
                ))}
              </div>
            </section>
          )}
        </div>
      )}
    </>
  )
}
